/* eslint no-unused-vars: 0 */
import React, { useState } from 'react';
import axios from 'packs/axios';

const ToggleVat = ({ vatStatus, disabled }) => {
  const [toggled, setToggled] = useState(JSON.parse(vatStatus));
  const toggle = async () => {
    if (disabled) return false;
    await setToggled(!toggled);

    return axios('/toggle_vat', {
      method: 'post',
      headers: {
        'Content-Type': 'text/javascript',
        Accept: 'text/javascript',
      },
    })
      .then(() => {
        window.location.reload();
      })
      .catch(() => {
        window.location.reload();
      });
  };

  return (
    <div
      className={
        disabled ? 'toggle-vat-wrapper disabled' : 'toggle-vat-wrapper '
      }
      data-testid="toggle-vat">
      <button
        type="button"
        className={toggled ? 'inactive toggle-vat-text' : 'toggle-vat-text'}
        onClick={toggle}>
        Inc VAT
      </button>
      <label htmlFor="toggle-vat-switch" className="switch">
        <input
          type="checkbox"
          id="toggle-vat-switch"
          aria-label="Toggle VAT"
          className={toggled ? 'toggled' : ''}
          onChange={toggle}
        />
        <span className="slider" />
      </label>
      <button
        type="button"
        className={!toggled ? 'inactive toggle-vat-text' : 'toggle-vat-text'}
        onClick={toggle}>
        Ex VAT
      </button>
    </div>
  );
};

export default ToggleVat;
